import { useEffect, useState } from "react";
import {
  importSkill,
  listSkills,
  type CatalogSkill,
  type Skill,
} from "@/api/agents";
import { useT } from "@/i18n";
import { settingsSkillsMessages } from "@/i18n/messages/settings-skills";
import { useAgentStore } from "@/stores/agent-store";
import { SkillCatalogBrowser } from "./skill-catalog-browser";
import { SettingsFieldError } from "./settings-text-field";

export function SkillsBrowsePage() {
  const t = useT(settingsSkillsMessages);
  const [skills, setSkills] = useState<Skill[]>([]);
  const [loadFailed, setLoadFailed] = useState(false);
  useEffect(() => {
    let current = true;
    void listSkills()
      .then((items) => {
        if (current)
          setSkills((added) => [
            ...items,
            ...added.filter(
              (item) => !items.some((entry) => entry.slug === item.slug),
            ),
          ]);
      })
      .catch(() => {
        if (current) setLoadFailed(true);
      });
    return () => {
      current = false;
    };
  }, []);
  async function add(entry: CatalogSkill) {
    const added = await importSkill({
      slug: entry.slug,
      name: entry.name,
      description: entry.description,
    });
    setSkills((items) =>
      items.some((item) => item.slug === added.slug)
        ? items
        : [...items, added],
    );
    void useAgentStore.getState().fetchSkills();
  }
  return (
    <div data-testid="settings-page-skills-browse">
      <SkillCatalogBrowser
        existingSlugs={new Set(skills.map((item) => item.slug))}
        onImport={add}
        expanded
        page
      />
      <SettingsFieldError
        error={loadFailed ? t("installedSkillsError") : null}
        testId="skills-installed-error"
      />
    </div>
  );
}
